import React from "react";

import shareImage from "../../../Images/share-data-nobackground.png";
import {CancelContinueButtons} from "../../Controls/CancelContinueButtons";
import {PageLayoutWithGetData} from "../../Controls/PageLayout";
import BackLink from "../../Controls/BackLink";
import {useNavigate} from "react-router-dom";
import {Box, Center, Heading, Image, Text} from "@chakra-ui/react";
import {NumberedList} from "../../Controls/NumberedList";

const items = [
  ["Consent", "to share your data with us"],
  ["Connect", "to your bank (we wont see this information)"],
  ["Confirm", "with your bank that you'll share data with us"],
];

export default function DataSharingInstructions() {
  const navigate = useNavigate();
  return (
    <PageLayoutWithGetData loading={false}>
      <BackLink page="/ValueProposition" />
      <Heading variant="pageHeading">How to share your data</Heading>
      <Center>
        <Image w="70%" src={shareImage} mb={3} alt="Data Sharing page" />
      </Center>

      <Box my={2} mx={4}>
        <Text fontWeight="bold" mb={5}>
          To share your data, we'll ask you to:
        </Text>
        <NumberedList
          items={items.map(([heading, text], i) => (
            <Text key={i} fontSize="md">
              <strong>{heading}</strong> {text}
            </Text>
          ))}
        />
        <Text mb={2} mt={6}>
          This should only take a few minutes.
        </Text>
        <Text>We'll walk you through each step.</Text>
      </Box>
      <CancelContinueButtons
        role="footer"
        OnclickContinue={() => navigate("/DataRequest")}
        btnContinueText="Continue"
        step="DataSharingInstructions"
      />
    </PageLayoutWithGetData>
  );
}
